var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7002 12.2405C37.7258 12.6202 37.7258 13 37.7258 13.3832C37.7258 25.0602 29.0579 38.5274 13.2083 38.5274V38.5204C8.52627 38.5274 3.9415 37.152 0 34.5586C0.680804 34.6426 1.36502 34.6846 2.05094 34.6864C5.93102 34.6899 9.70018 33.3547 12.7527 30.8961C9.06545 30.8243 5.83205 28.3588 4.7025 24.7592C5.99415 25.0147 7.32505 24.9622 8.59281 24.607C4.57282 23.774 1.68068 20.1518 1.68068 15.945C1.68068 15.9065 1.68068 15.8698 1.68068 15.833C2.87849 16.5172 4.21962 16.897 5.59147 16.939C1.80524 14.3439 0.638147 9.1782 2.92456 5.13945C7.29945 10.6604 13.7543 14.0166 20.6835 14.3719C19.989 11.3026 20.9377 8.08627 23.1764 5.92865C26.6469 2.58286 32.1053 2.75435 35.3677 6.31188C37.2975 5.92165 39.1471 5.19545 40.8397 4.16651C40.1965 6.21214 38.8502 7.94978 37.0518 9.05396C38.7598 8.84747 40.4285 8.3785 42 7.6628C40.8431 9.44068 39.386 10.9893 37.7002 12.2405Z",
    fill: "#1D9BF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.b06d7aef9dd9dfa65c7ad58a4ea707f1.svg";
export { ForwardRef as ReactComponent };